import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const Layout = styled.div`
	background-color: ${(props) =>
		props.backGroundColor ? props.backGroundColor : '#FAF3E6'};
	display: flex;
	padding: 80px 0px 70px 0px;
	flex-direction: column;
	align-items: center;
	gap: 80px;
	${EmotionBreakpoint('mobile')} {
		display: flex;
		width: 100%;
		flex-direction: column;
		width: 375px;
		padding: 60px 0px;
		flex-direction: column;
		align-items: center;
		gap: 50px;
	}
	${EmotionBreakpoint('tablet')} {
	}
	${EmotionBreakpoint('notMobile')} {
	}
`;

const HeadLine = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	${EmotionBreakpoint('mobile')} {
		width: 345px;
	}
`;

const HeadLineText = styled.div`
	align-self: stretch;
	color: #222;
	text-align: center;
	font-family: escrow;
	font-size: 32px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	.law & {
		font-family: 'Noto Serif';
	}
	${EmotionBreakpoint('mobile')} {
		font-size: 26px;
	}
	${EmotionBreakpoint('tablet')} {
		font-size: 26px;
	}
`;

const DescriptionContainer = styled.div`
	display: flex;
	align-items: center;
	background: ${(props) =>
		props.backGroundColor ? props.backGroundColor : '#FAF3E6'};
	gap: 50px;
	max-width: 100%;
	max-height: 100%;
	width: 100%;
	height: 572px;
	flex-direction: column;

	hr {
		width: 539px;
		border: none;
		height: 1px;
		background-color: ${(props) =>
			props.contentfulData.horizontalRulerColor
				? props.contentfulData.horizontalRulerColor
				: '#9a7f6b'};
	}
	${EmotionBreakpoint('tablet')} {
		hr {
			margin: 5px;
			width: 320px;
			border: none;
			height: 1px;
			background-color: ${(props) =>
				props.contentfulData.horizontalRulerColor
					? props.contentfulData.horizontalRulerColor
					: '#9a7f6b'};
		}
	}

	${EmotionBreakpoint('mobile')} {
		display: flex;
		width: 345px;
		flex-direction: column;
		align-items: flex-start;
		gap: 50px;
		max-width: 100%;
		max-height: 100%;
		width: 345px;
		height: 100%;
		hr {
			width: 345px;
		}
	}
`;
const StyledLine = styled.div`
	display: flex;
	max-width: 1161px;
	width: 100%;
	border: none;
	height: 1px;
	background-color: #9a7f6b;
	background-color: ${(props) =>
		props.contentfulData.horizontalRulerColor
			? props.contentfulData.horizontalRulerColor
			: '#9a7f6b'};
	${EmotionBreakpoint('mobile')} {
		display: none;
	}
`;
const DescriptionCard = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 50px;

	.TextContainer {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 15px;

		.HeaderContainer {
			display: flex;
			gap: 10px;
			flex-direction: column;
			align-items: flex-start;

			.nameplate {
				display: none;
			}

			.collectionName {
				color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
				text-align: center;
				font-family: 'Open Sans', sans-serif;
				font-size: 18px;
				font-style: normal;
				font-weight: 700;
				line-height: 20.7px;
				text-transform: uppercase;

				@media (max-width: 1024px) {
					margin-left: 25%;
				}

				${EmotionBreakpoint('tablet')} {
					margin-left: 0;
				}

				${EmotionBreakpoint('mobile')} {
					margin-left: 0;
				}
			}

			.collection {
				color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
				text-align: center;
				font-family:${(props) =>
					props.fontFamily ? props.fontFamily : 'Oswald, sans-serif'};
				font-size: 40px;
				font-style: normal;
				font-weight: 600;
				line-height: 35.7px;
				text-transform: uppercase;
				letter-spacing: -0.48px;

				@media (max-width: 1024px) {
					transform: ${(props) => (props.index % 2 === 0 ? 'none' : 'translateX(22%)')};
				}

				${EmotionBreakpoint('tablet')} {
					transform: none;
				}

				${EmotionBreakpoint('mobile')} {
					transform: none;
				}
			}
		}

		.textone {
			width: 539px;
			color: #222;
			text-align: justify;
			font-family: ITC Cheltenham Std;
			font-size: 24px;
			font-style: italic;
			font-weight: 400;
			line-height: 120%;
			letter-spacing: -1px;
			text-align: left;

			@media (max-width: 1024px) {
				max-width: ${(props) => (props.index % 2 === 0 ? '85%' : '100%')};
				margin-left: ${(props) => (props.index % 2 === 0 ? '0' : '14%')};
				padding-right: ${(props) => (props.index % 2 === 0 ? '0' : '30px')};
			}

			${EmotionBreakpoint('tablet')} {
				margin-left: 0;
				padding-right: 0
			}

			${EmotionBreakpoint('mobile')} {
				max-width: 100%;
				margin-left: 0;
				padding-right: ${(props) => (props.index % 2 === 0 ? '10px' : '0')};
			}
		}

		.texttwo {
			width: 539px;
			color: #222;
			text-align: justify;
			font-family: 'Open Sans', sans-serif;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 22.4px;
			text-align: left;

			@media (max-width: 1024px) {
				max-width: ${(props) => (props.index % 2 === 0 ? '85%' : '100%')};
				margin-left: ${(props) => (props.index % 2 === 0 ? '0' : '14%')};
				padding-right: ${(props) => (props.index % 2 === 0 ? '0' : '30px')};
			}

			${EmotionBreakpoint('tablet')} {
				margin-left: 0;
				padding-right: 0
			}

			${EmotionBreakpoint('mobile')} {
				max-width: 100%;
				margin-left: 0;
				padding-right: ${(props) => (props.index % 2 === 0 ? '10px' : '0')};
			}
		}

		.textthree {
			.signature-collection {
				list-style: disc;
				padding-left: 17px;
				text-align: left;
			}

			width: 539px;
			color: #222;
			text-align: justify;
			font-family: 'Open Sans', sans-serif;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 22.4px;

			@media (max-width: 1024px) {
				max-width: ${(props) => (props.index % 2 === 0 ? '85%' : '100%')};
				margin-left: ${(props) => (props.index % 2 === 0 ? '0' : '14%')};
				padding-right: ${(props) => (props.index % 2 === 0 ? '0' : '30px')};
			}

			${EmotionBreakpoint('tablet')} {
				margin-left: 0;
				padding-right: 0;
			}

			${EmotionBreakpoint('mobile')} {
				max-width: 100%;
				margin-left: 0;
				padding-right: 0;
			}
		}
		a {
			padding-right: 200px;
			cursor: pointer;
    		color: transparent;

			@media (max-width: 1024px) {
				margin-left: ${(props) => (props.index % 2 === 0 ? '0' : '14%')};
			}

			${EmotionBreakpoint('tablet')} {
				margin-left: 0;
			}

			${EmotionBreakpoint('mobile')} {
				max-width: 100%;
				margin-left: 0;
			}

			button {
				display: flex;
				padding: 15px 25px 14px 25px;
				justify-content: center;
				align-items: center;
				gap: 10px;
				background: ${(props) =>
					props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)'};
				color: #fff;
				text-align: center;
				font-family: 'Open Sans', sans-serif;
				font-size: 12px;
				font-style: normal;
				font-weight: 600;
				line-height: 14px;
				letter-spacing: 0.75px;
				text-transform: uppercase;
				border: 0px;
			}
		}
		}
	}
	.ImgContainer {
		img {
			width: 572px;
			height: 572px;
			flex-shrink: 0;
		}
		
	}
	${EmotionBreakpoint('tablet')} {
		gap: 25px;
		.ImgContainer {
			img {
				width: 365px;
				height: 503px;
				flex-shrink: 0;
			}
		}
		.TextContainer {
			display: flex;
			flex-direction: column;
			align-items:flex-start;
			gap: 8px;
			order: 2;

			.HeaderContainer {
				display: flex;
				gap: 14apx;
				flex-direction: column;
				align-items: flex-start;
				.nameplate {
					display: none;
				}
				.collectionName {
					color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
					text-align: center;
					font-family: 'Open Sans', sans-serif;
					font-size: 15px;
					font-style: normal;
					font-weight: 700;
					line-height: 20.7px;
					text-transform: uppercase;

				}
				.collection {
					color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
					text-align: center;
					font-family: ${(props) =>
						props.fontFamily ? props.fontFamily : 'Oswald, sans-serif'};
					font-size: 27px;
					font-style: normal;
					font-weight: 600;
					line-height: 35.7px;
					text-transform: uppercase;
					img {
						width: 245px;
					}
				}
			}
			.textone {
				width: 345px;
				color: #222;
				text-align: justify;
				font-family: ITC Cheltenham Std;
				font-size: 18px;
				font-style: italic;
				font-weight: 400;
				line-height: 120%;
				letter-spacing: -1px;
				text-align: left;
			}
			.texttwo {
				width: 345px;
				color: #222;
				text-align: justify;
				font-family: 'Open Sans', sans-serif;
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 22.4px;
				text-align: left;
			}
			.textthree {
				.signature-collection {
					list-style: disc;
					padding-left: 17px;
					text-align: left;
					padding: 0px;
				}
				li{
					margin-bottom: -7px;
				}

				width: 335px;
				color: #222;
				text-align: justify;
				font-family: 'Open Sans', sans-serif;
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 22.4px;
			}
			a {
				padding-right: 0px;
				cursor: pointer;
    			color: transparent;	

				button {
					display: flex;
					padding: 10px 15px 10px;
					justify-content: center;
					align-items: center;
					gap: 10px;
					background: ${(props) =>
						props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)'};
					color: #fff;
					text-align: center;
					font-family: 'Open Sans', sans-serif;
					font-size: 12px;
					font-style: normal;
					font-weight: 600;
					line-height: 14px;
					letter-spacing: 0.75px;
					text-transform: uppercase;
					border: 0px;
				}
			}
		}
	}

	${EmotionBreakpoint('mobile')} {
		flex-direction: column;
		gap: 50px;
		.ImgContainer {
			img {
				width: 345px;
				height: 345px;
				flex-shrink: 0;
			}
		}
		.TextContainer {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 20px;
			order: 2;

			.HeaderContainer {
				display: flex;
				gap: 14apx;
				flex-direction: column;
				align-items: center;

				.nameplate {
					width: 177px;
					display: flex;
					flex-direction: column;
					padding: 6px 15px 5px 17px;
					align-items: center;
					gap: 10px;
					border-radius: 40px;
					color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
					font-family: 'Open Sans', sans-serif;
					font-size: 10px;
					font-style: normal;
					font-weight: 600;
					line-height: 12px;
					letter-spacing: 0.5px;
					text-transform: uppercase;
				}

				.collectionName {
					color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
					text-align: center;
					font-family: 'Open Sans', sans-serif;
					font-size: 18px;
					font-style: normal;
					font-weight: 700;
					line-height: 20.7px;
					text-transform: uppercase;

				}

				.collection {
					color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
					text-align: center;
					font-family: ${(props) =>
						props.fontFamily ? props.fontFamily : 'Oswald, sans-serif'};
					font-size: 30px;
					font-style: normal;
					font-weight: 600;
					line-height: 35.7px;
					text-transform: uppercase;
					img {
						width: 245px;
					}
				}
			}

			.textone {
				width: 345px;
				color: #222;
				text-align: justify;
				font-family: ITC Cheltenham Std;
				font-size: 20px;
				font-style: italic;
				font-weight: 400;
				line-height: 120%;
				letter-spacing: -1px;
				text-align: left;
			}

			.texttwo {
				width: 345px;
				color: #222;
				text-align: justify;
				font-family: 'Open Sans', sans-serif;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 22.4px;
				text-align: left;
			}

			.textthree {
				.signature-collection {
					list-style: disc;
					padding-left: 17px;
					text-align: left;
				}

				width: 335px;
				color: #222;
				text-align: justify;
				font-family: 'Open Sans', sans-serif;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 22.4px;
			}
			a {
				padding-right: 0px;
				cursor: pointer;
    			color: transparent;	

				button {
					display: flex;
					padding: 15px 25px 14px 25px;
					justify-content: center;
					align-items: center;
					gap: 10px;
					background: ${(props) =>
						props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)'};
					color: #fff;
					text-align: center;
					font-family: 'Open Sans', sans-serif;
					font-size: 12px;
					font-style: normal;
					font-weight: 600;
					line-height: 14px;
					letter-spacing: 0.75px;
					text-transform: uppercase;
					border: 0px;
				}
			}
		}
	}
`;

const BrothersDescription = ({ contentfulData }) => {
	return (
		<Layout backGroundColor={contentfulData?.backGroundColor}>
			<HeadLine>
				<HeadLineText>
					{contentfulData?.descriptionHeadline?.content[0]?.content[0]?.value}
				</HeadLineText>
			</HeadLine>

			{contentfulData?.brothersDescription?.map((item, index) => (
				<>
					<DescriptionContainer
						key={index}
						backGroundColor={contentfulData?.backGroundColor}
						contentfulData={contentfulData}
						index={index}
					>
						<DescriptionCard
							dangerouslySetInnerHTML={{ __html: item?.fields?.htmlContent }}
							cardColor={item?.fields?.cssLayout}
							fontFamily={item?.fields?.customStyle}
							index={index}
						></DescriptionCard>
					</DescriptionContainer>
					{(index === 0 || index === 1) && (
						<StyledLine contentfulData={contentfulData}></StyledLine>
					)}
				</>
			))}
		</Layout>
	);
};
export default BrothersDescription;
